// extracted by mini-css-extract-plugin
export var lg = "_4h-4";
export var md = "_4h-3";
export var sm = "_4h-2";
export var xs = "_4h-1";
export var xxs = "_4h-0";